import React, { useState, useEffect } from 'react';
import { Button, Card, Col, Container, Image, Nav, Navbar, NavDropdown, Row } from 'react-bootstrap';
import { Link, Element } from 'react-scroll';
import ScrollToTop from 'react-scroll-to-top';
import { FaAngleUp } from "react-icons/fa6";
import { Helmet } from "react-helmet";
import { useTranslation } from 'react-i18next';
import { SupportedLanguages, TSupportedLanguages } from './i18n';
import './App.css';

function App(props: any) {

  const { language } = props;
  const { t, i18n } = useTranslation();

  const [currentLanguage, setCurrentLanguage] = useState(language || 'es');

  useEffect(() => {
    i18n.changeLanguage(currentLanguage);
    document.documentElement.lang = currentLanguage;
    console.log(SupportedLanguages);
  }, []);

  const renderNavDropdownTitle = () => {
    return (
      <>
        <div className="d-inline-block">
          <div className="d-flex align-items-center">
            <img src={'/assets/images/language/' + currentLanguage + '.png'} style={{ width: '16px'}} />
            <span className="ms-1 text-uppercase">{i18n.t('language')}</span>
          </div>
        </div>
      </>
    );
  }

  const renderNavDropdownContent = SupportedLanguages.filter(lang => lang !== currentLanguage).map((lang: TSupportedLanguages) => {
    const name = i18n.t('language', { lng: lang });
    return (
      <NavDropdown.Item href={"/" + lang}>
        <div className="d-inline-block">
          <div className="d-flex align-items-center">
            <img src={'/assets/images/language/' + lang + '.png'} style={{ width: '16px'}} />
            <span className="ms-1 text-uppercase">{name}</span>
          </div>
        </div>
      </NavDropdown.Item>
    );
  });

  return (
    <div className="App">
      <Helmet>
        <title>Stonetech ECM</title>
      </Helmet>
      <div className="z-n1 position-fixed d-flex justify-content-center align-items-center vh-100 vw-100 flex-row" style={{ backgroundColor: '#f2f5fb' }}>
        <div style={{ background: 'transparent', width: '25vw', height: '100vh', borderRight: '1px solid #dbe1ea' }}></div>
        <div style={{ background: 'transparent', width: '25vw', height: '100vh', borderRight: '1px solid #dbe1ea' }}></div>
        <div style={{ background: 'transparent', width: '25vw', height: '100vh', borderRight: '1px solid #dbe1ea' }}></div>
        <div style={{ background: 'transparent', width: '25vw', height: '100vh' }}></div>
      </div>
      <ScrollToTop smooth component={<FaAngleUp size={25} />} />
      <Navbar expand="lg" className="bg-body-transparent fs-4 fw-bold" >
        <Container>
          <Navbar.Brand>
            <img src="/assets/images/stonetechecm.png" alt="Stone Tech Ecm" style={{ width: '220px' }} />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav" style={{ fontSize: "0.9rem" }}>
            <Nav className="ms-auto">
              <Link className="me-4 text-uppercase nav-link" to="section-2" smooth={true} duration={500} offset={-0}>{t("news")}</Link>
              <Link className="me-4 text-uppercase nav-link" to="section-3" smooth={true} duration={500} offset={-0}>{t("contact-us")}</Link>
              <NavDropdown title={renderNavDropdownTitle()} id="basic-nav-dropdown">
                {renderNavDropdownContent}
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <Element name="section-1">
        <section>
          <Container className="my-4">
            <Row>
              <Col md={{ span: 8, offset: 4 }} className="p-0">
                <Image className="w-100" src="/assets/images/robot.jpg" />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col className="mb-3 bg-primary text-light p-4">
                <p>{t('text-section-1')}</p>
              </Col>
            </Row>
          </Container>
        </section>
      </Element>
      <Element name="section-2">
        <section>
          <Container className="mb-4">
            <Row className="mb-3">
              <Col>
                <h1 className="text-uppercase text-center fw-bold">{t('news')}</h1>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col>
                <h4 className="text-uppercase text-center">{t('title-section-2')}</h4>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col>
                <h6 className="text-center">{t('subtitle-section-2')}</h6>
              </Col>
            </Row>
            <Row>
              <Col className="p-0">
                <Image className="w-100" src="/assets/images/machine.jpg" />
              </Col>
            </Row>
            <Row className="mb-4">
              <Col className="mb-3 bg-primary text-light p-4">
                <p>{t('content-section-2')}</p>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col>
                <h3 className="text-center">{t('quetion-section-2')}</h3>
              </Col>
            </Row>
            <Row>
              <Col>
                <Card className="feature-card m-md-4">
                  <Card.Body>
                    <Card.Title>{t('feature-1-title')}</Card.Title>
                    <Card.Text>{t('feature-1-desc')}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col>
                <Card className="feature-card m-md-4">
                  <Card.Body>
                    <Card.Title>{t('feature-2-title')}</Card.Title>
                    <Card.Text>{t('feature-2-desc')}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col>
                <Card className="feature-card m-md-4">
                  <Card.Body>
                    <Card.Title>{t('feature-3-title')}</Card.Title>
                    <Card.Text>{t('feature-3-desc')}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col>
                <Card className="feature-card m-md-4">
                  <Card.Body>
                    <Card.Title>{t('feature-4-title')}</Card.Title>
                    <Card.Text>{t('feature-4-desc')}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col>
                <Card className="feature-card m-md-4">
                  <Card.Body>
                    <Card.Title>{t('feature-5-title')}</Card.Title>
                    <Card.Text>{t('feature-5-desc')}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col>
                <Card className="feature-card m-md-4">
                  <Card.Body>
                    <Card.Title>{t('feature-6-title')}</Card.Title>
                    <Card.Text>{t('feature-6-desc')}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col>
                <Card className="feature-card m-md-4">
                  <Card.Body>
                    <Card.Title>{t('feature-7-title')}</Card.Title>
                    <Card.Text>{t('feature-7-desc')}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col>
                <Card className="feature-card m-md-4">
                  <Card.Body>
                    <Card.Title>{t('feature-8-title')}</Card.Title>
                    <Card.Text>{t('feature-8-desc')}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <Row className="mb-5">
              <Col>
                <Row className="mb-2">
                  <Col>
                    <h3 className="text-uppercase text-center">{t('ideal-for')}</h3>
                  </Col>
                </Row>
                <Row className="bg-primary">
                  <Col md={{ span: 6, offset: 3 }} className="bg-primary text-light p-4">
                    <ul>
                      <li>{t('ideal-for-1')}</li>
                      <li>{t('ideal-for-2')}</li>
                      <li>{t('ideal-for-3')}</li>
                      <li>{t('ideal-for-4')}</li>
                      <li>{t('ideal-for-5')}</li>
                    </ul>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </section>
      </Element>
      <Element name="section-3">
        <section>
          <Container className="mb-4">
            <Row className="mb-3">
              <Col>
                <h1 className="text-uppercase text-center fw-bold">{t('contact-us')}</h1>
              </Col>
            </Row>
            <Row>
              <Col>
                <Row>
                  <Col>
                    <h3 className="text-center">{t('quetion-section-3')}</h3>
                  </Col>
                </Row>
                <Row>
                  <Col className="mb-3 bg-primary text-light p-4">
                    <p>{t('content-section-3')}</p>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col>
                <Row className="mb-3">
                  <Col className='d-flex flex-column flex-md-row'>
                    <div className="me-1">{t('contact')}:</div>
                    <div>Miguel Del Río Dacosta</div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col className='d-flex flex-column flex-md-row'>
                    <div className="me-1">Email:</div>
                    <div><a href="mailto:info@stonetechecm.com">info@stonetechecm.com</a></div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col className='d-flex flex-column flex-md-row'>
                    <div className="me-1">{t('phone')}:</div>
                    <div>+34 670 766 602</div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col className='d-flex flex-column flex-md-row'>
                    <div className="me-1">{t('address')}:</div>
                    <div style={{ maxWidth: '300px' }}>Avda. Alcalde Lavadores No.124, CP.36214, Vigo, Pontevedra, {t('spain')}</div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </section>
      </Element>
      <footer className='text-white mt-auto' style={{ backgroundColor: '#062235' }}>
        <Container className="text-center py-4">
          <div className="fs-6"><small>&copy; 2025 {t('by')} Stonetech Ecm S.L.</small></div>
          <div><small>{t('all-rights-reserved')}</small></div>
        </Container>
      </footer>
    </div>
  );
}

export default App;
